import React from "react";
import Flagship from "../../core/flagship";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../actions/appActions";
import SingleRecordFiles from "../misc/SingleRecordFiles";
import SingleRecordHeader from "../misc/SingleRecordHeader";
import CommentBox from "../misc/CommentBox";
import FavoriteIcon from "../misc/FavoriteIcon";
import SubscribeButton from "../misc/SubscribeButton";
import SingleRecordView from "../misc/SingleRecordView";
import SingleRecordHistory from "../misc/SingleRecordHistory";
import SingleRecordComments from "../misc/SingleRecordComments";
import SingleRecordEdit from "../misc/SingleRecordEdit";
import { mergeDeep, empty, isEqual } from "../../utils/helpers";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/singleRecord.scss";

import {
  Grid,
  Table,
  Loader,
  Header,
  Button,
  Icon,
  Segment,
  Modal,
  Label,
  Divider,
  Tab,
  Menu,
} from "semantic-ui-react";

function normalizeArray(value) {
  return Array.isArray(value) ? value : [];
}

function normalizeRecordData(value = {}) {
  return Object.assign({}, value, {
    record: value && value.record ? value.record : {},
    data: normalizeArray(value && value.data),
    subscribers: normalizeArray(value && value.subscribers),
    favorited: normalizeArray(value && value.favorited),
  });
}

class SingleRecord extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.getRecordFields = this.getRecordFields.bind(this);
    this.getRecordData = this.getRecordData.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
    this.cancelExit = this.cancelExit.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.abandonChanges = this.abandonChanges.bind(this);
    this.editModeChange = this.editModeChange.bind(this);
    this.recordNameChange = this.recordNameChange.bind(this);
    this.extraChange = this.extraChange.bind(this);
    this.onAddLineItem = this.onAddLineItem.bind(this);
    this.onStatusChange = this.onStatusChange.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.hasContract = this.hasContract.bind(this);
    this.hasAdvisrIo = this.hasAdvisrIo.bind(this);
    this.onChangeLaunchDate = this.onChangeLaunchDate.bind(this);
    this.cancelLaunchDateChange = this.cancelLaunchDateChange.bind(this);
    this.saveLaunchDate = this.saveLaunchDate.bind(this);
    this.getViewingParams = this.getViewingParams.bind(this);
    this.onCloseModals = this.onCloseModals.bind(this);
    this.duplicateRecord = this.duplicateRecord.bind(this);
    this.updateLineItems = this.updateLineItems.bind(this);
    this.onCancelRecord = this.onCancelRecord.bind(this);
    this.onSubmitRecord = this.onSubmitRecord.bind(this);
    this.onReactivateRecord = this.onReactivateRecord.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleCommentFilterSearchChange =
      this.handleCommentFilterSearchChange.bind(this);
    this.handleCommentFilterUserChange =
      this.handleCommentFilterUserChange.bind(this);
    this.getHistoryCount = this.getHistoryCount.bind(this);
    this.getCommentCount = this.getCommentCount.bind(this);
  }

  getViewingParams(nextProps = false) {
    let key =
      nextProps === false
        ? this.props.routeParams.splat
        : nextProps.routeParams.splat;
    let viewingChild = false;

    let parts = key.split("/");

    if (parts.length > 1) {
      key = parts[0];
      if (parts[1] === "focus") {
        viewingChild = parts[2];
      }
    }

    return {
      key,
      viewingChild,
    };
  }

  getInitialState(nextProps = false) {
    const props = nextProps === false ? this.props : nextProps;
    let tabActive = this.getTabIndex("view", props);
    if (props.route.mode === "edit") {
      tabActive = this.getTabIndex("edit", props);
    } else if (props.route.mode === "history") {
      tabActive = this.getTabIndex("history", props);
    }

    return Object.assign(this.getViewingParams(nextProps), {
      editing: false,
      inputValue: false,
      confirmExit: false,
      recordData: normalizeRecordData(),
      nextLocation: "",
      isAdvisr: false,
      modified: false,
      errors: [],
      requiredMissing: false,
      showLaunchDateModal: false,
      launchDate: moment(),
      lineItems: [],
      hasContract: false,
      loading: true,
      activeTab: tabActive,
      historyCount: false,
      commentCount: false,
      recordFields: [],
      fieldData: [],
      commentFilterUser: false,
      commentFilterSearch: false,
    });
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
  }

  componentDidMount() {
    if (
      !empty(this.props.userInstance) &&
      !empty(this.props.instance) &&
      this.props.userInstance !== this.props.instance
    ) {
      Flagship.redirect("/" + this.props.route.type + "s");
    } else {
      this.getRecordData();

      document.title =
        (this.props.route.mode === "edit" ? "Editing " : "") +
        this.props.route.niceName +
        " / Loading...";
    }

    if (this.props.route.type === "rfp" && this.props.userRole === "ae") {
      Flagship.redirect("/access-denied");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.route.type === "rfp" && nextProps.userRole === "ae") {
      Flagship.redirect("/access-denied");
    }

    if (
      nextProps.instance !== this.props.instance &&
      this.state.loading === false &&
      !empty(this.state.recordData.record.instance) &&
      nextProps.instance !== this.state.recordData.record.instance
    ) {
      Flagship.redirect("/" + nextProps.route.type + "s");
    }

    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState(this.getInitialState(nextProps), this.getRecordData);
    }
  }

  getAvailableTabKeys(props = this.props) {
    return props.userRole !== "ae" && props.accessLevel === 2
      ? ["view", "edit", "history", "comments"]
      : ["view", "history", "comments"];
  }

  getTabIndex(tabKey, props = this.props) {
    const index = this.getAvailableTabKeys(props).indexOf(tabKey);

    return index === -1 ? 0 : index;
  }

  onCloseModals() {
    let baseUrl = window.location.pathname.substr(
      0,
      window.location.pathname.indexOf("/focus/"),
    );
    if (!empty(baseUrl)) {
      this.props.router.push(baseUrl);
    }
  }

  onSubmitRecord() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.post(
      "submit-record/" +
        this.props.route.type +
        "/" +
        this.state.recordData.record.id,
      {},
      function (response) {
        if (response.data.success === true) {
          Flagship.notify(self.props.route.niceName + " submitted!", "success");
          Flagship.event(
            "submit-" + self.props.route.type,
            {
              recordData: self.state.recordData.record,
            },
            self.state.recordData.record.id,
            self.props.userId,
          );
        } else {
          Flagship.notify("An error occurred.", "error");
        }
        self.getRecordData();
      },
      function (error) {
        Flagship.notify("An error occurred: " + error, "error");
      },
    );
  }

  onCancelRecord() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    Flagship.changeRecordStatus(
      this.state.recordData.record.id,
      "trash",
      function (response) {
        if (response.data.success === true) {
          Flagship.notify(self.props.route.niceName + " canceled.", "success");
        } else {
          Flagship.notify("An error occurred..", "error");
        }
        self.getRecordData();
      },
    );
  }

  onReactivateRecord() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    Flagship.changeRecordStatus(
      this.state.recordData.record.id,
      "draft",
      function (response) {
        if (response.data.success === true) {
          Flagship.notify(
            self.props.route.niceName + " resurrected.",
            "success",
          );
        } else {
          Flagship.notify("An error occurred..", "error");
        }
        self.getRecordData();
      },
    );
  }

  updateLineItems(value = []) {
    this.setState({
      lineItems: normalizeArray(value),
    });
  }

  getHistoryCount() {
    let self = this;
    const recordId = self.state.recordData.record.id;

    Flagship.get(
      "log/count",
      {
        target: recordId,
      },
      function (response) {
        if (
          typeof self.state.recordData.record === "undefined" ||
          self.state.recordData.record.id !== recordId
        ) {
          return;
        }

        if (response.data.success === true) {
          self.setState({
            historyCount: response.data.count,
          });
        }
      },
    );
  }

  getCommentCount() {
    let self = this;
    const recordId = self.state.recordData.record.id;

    Flagship.get(
      "comments/count/" + recordId,
      {},
      function (response) {
        if (
          typeof self.state.recordData.record === "undefined" ||
          self.state.recordData.record.id !== recordId
        ) {
          return;
        }

        if (response.data.success === true) {
          self.setState({
            commentCount: response.data.count,
          });
        }
      },
    );
  }

  getRecordFields() {
    let self = this;
    const type = this.props.route.type;
    const recordId = this.state.recordData.record.id;

    Flagship.get(
      "fields/" + type,
      {
        active: true,
        withData: recordId,
        context: "record",
        instance: self.props.instance,
      },
      function (response) {
        if (
          typeof self.state.recordData.record === "undefined" ||
          self.state.recordData.record.id !== recordId ||
          self.props.route.type !== type
        ) {
          return;
        }

        if (response.data.success === true) {
          self.setState({
            recordFields: response.data.results,
          });
        }
      },
      function (err) {
        Flagship.error(
          "Error getting fields to edit record: " + err,
          recordId,
          self.props.userId,
        );
      },
    );
  }

  getRecordData() {
    let key = this.state.key;
    let type = this.props.route.type;
    let self = this;

    Flagship.get(
      "records/" + type + "/" + key,
      {
        extra: {
          extra1: Flagship.config.records[type].extra1,
          extra2: Flagship.config.records[type].extra2,
          extra3: Flagship.config.records[type].extra3,
          extra4: Flagship.config.records[type].extra4,
        },
      },
      function (response) {
        if (self.state.key !== key || self.props.route.type !== type) {
          return;
        }

        if (response.data.success === true) {
          const normalizedRecordData = normalizeRecordData(response.data);

          if (normalizedRecordData.record.instance !== self.props.instance) {
            if (
              self.props.userInstance !== "SHIFT" &&
              self.props.userInstance !== "Standard"
            ) {
              self.props.actions.changeInstance(
                normalizedRecordData.record.instance,
              );
              Flagship.setInstance(normalizedRecordData.record.instance);
            }
          }

          const isAdvisr = !empty(normalizedRecordData.record.extra4);

          let fieldData = [];

          normalizedRecordData.data.forEach(
            (field) => (fieldData[field.field_id] = field.field_value),
          );

          self.setState(
            {
              recordData: normalizedRecordData,
              nextLocation:
                "/" +
                normalizedRecordData.record.record_type +
                "/view/" +
                normalizedRecordData.record.record_key,
              loading: false,
              isAdvisr: isAdvisr,
              fieldData,
            },
            function () {
              self.getHistoryCount();
              self.getCommentCount();
              self.getRecordFields();
              self.props.actions.setClientIntoStore(
                normalizedRecordData.record.record_type,
                normalizedRecordData.record.id,
                isAdvisr,
              );
            },
          );
          localStorage.setItem(
            "initialRecordData",
            JSON.stringify(normalizedRecordData),
          );

          document.title =
            (self.props.route.mode === "edit" ? "Editing " : "") +
            self.props.route.niceName +
            " / " +
            self.state.recordData.record.record_name;
        } else {
          Flagship.error(
            "Error getting record '" + key + "' from Flagship API server.",
            null,
            self.props.userId,
          );
        }
      },
      function (err) {
        if (self.state.key !== key || self.props.route.type !== type) {
          return;
        }

        Flagship.error(
          "Error getting record '" + key + "' from Flagship API server: " + err,
          null,
          self.props.userId,
        );
      },
    );
  }

  isFavorite() {
    let currentUserId = this.props.userId;
    const favorited = normalizeArray(this.state.recordData.favorited);

    return favorited.some(function (user) {
      return parseInt(user.user_id) === currentUserId;
    });
  }

  editModeChange(e, newFieldValue, field) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let newRecordData = mergeDeep({}, this.state.recordData);

    let match = newRecordData.data.filter(function (item) {
      return item.id === field.field_id || item.field_id === field.field_id;
    });

    let newIndex = newRecordData.data.indexOf(match[0]);

    if (newIndex === -1) {
      let newField = mergeDeep({}, field);
      newField.field_value = newFieldValue;
      newField.field_id = field.field_id;
      newRecordData.data.push(newField);
    } else {
      newRecordData.data[newIndex].field_value = newFieldValue;
      newRecordData.data[newIndex].field_id = field.field_id;
    }

    window.onbeforeunload = function (e) {
      let text = "Are you sure you want to leave Flagship?";
      e.returnValue = text;
      return text;
    };

    let newFieldData = [...this.state.fieldData];
    newFieldData[field.id] = newFieldValue;
    this.setState({ fieldData: newFieldData });

    this.setState(
      {
        modified: true,
        recordData: newRecordData,
        fieldData: newFieldData,
      },
      this.checkRequired,
    );
  }

  recordNameChange(e, newName) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let newRecordData = mergeDeep({}, this.state.recordData);
    newRecordData.record.record_name = newName;

    window.onbeforeunload = function (e) {
      let text = "Are you sure you want to leave Flagship?";
      e.returnValue = text;
      return text;
    };

    this.setState(
      {
        modified: true,
        recordData: newRecordData,
      },
      this.checkRequired,
    );
  }

  extraChange(e, newValue, which) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let newRecordData = mergeDeep({}, this.state.recordData);
    newRecordData.record[which] = newValue;

    window.onbeforeunload = function (e) {
      let text = "Are you sure you want to leave Flagship?";
      e.returnValue = text;
      return text;
    };

    if (
      this.props.route.type === "io" &&
      (which === "extra4" || which === "extra1")
    ) {
      if (
        !empty(newValue.market) &&
        newValue.market !== this.state.recordData.record.market
      ) {
        newRecordData.record.market = newValue.market;
      }
    }
    if (this.props.route.type === "io" && which === "extra1") {
      if (newValue.id !== 1) {
        newRecordData.record.extra4 = "";
        this.setState({ isAdvisr: false });
      } else {
        this.setState({ isAdvisr: true });
      }
    }

    this.setState(
      {
        modified: true,
        recordData: newRecordData,
      },
      this.checkRequired,
    );
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    if (self.state.name === "") {
      requiredMissing = true;
    }

    if (self.state.childRequiredMissing === true) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.props.route.type].extra1.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.props.route.type].extra1.role_required &&
      empty(self.state.extra1)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.props.route.type].extra2.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.props.route.type].extra2.role_required &&
      empty(self.state.extra2)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.props.route.type].extra3.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.props.route.type].extra3.role_required &&
      empty(self.state.extra3)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.props.route.type].extra4.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.props.route.type].extra4.role_required &&
      empty(self.state.extra4)
    ) {
      requiredMissing = true;
    }

    normalizeArray(this.state.recordData.data).map(function (item) {
      if (
        (item.required === true || item.required === 1) &&
        empty(item.field_value)
      ) {
        requiredMissing = true;
      }
    });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  hasContract(result) {
    this.setState({
      hasContract: result,
    });
  }

  hasAdvisrIo(result) {
    this.setState({
      hasAdvisrIo: result,
    });
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) === -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  showRecordEditStatus() {
    if (this.props.accessLevel !== 2) {
      return null;
    }

    if (this.state.modified === true) {
      return (
        <Button
          floated="right"
          disabled={
            this.state.requiredMissing || this.state.errors.length
              ? true
              : false
          }
          primary
          onClick={this.saveAndExit}
          content="Save Changes"
        />
      );
    } else {
      return <span className="record-edit-status">No Changes to Save</span>;
    }
  }

  showLeaveConfirmation(nextLocation) {
    this.setState({
      confirmExit: true,
      nextLocation: nextLocation,
    });
  }

  saveRecord(callback = null) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    //Save
    Flagship.post(
      "save-record/" + this.state.recordData.record.id + "/",
      self.state.recordData,
      function (response) {
        if (response.data.success === true) {
          if (typeof callback === "function") {
            callback(response);

            self.setState({
              confirmExit: false,
              modified: false,
              activeTab: 0,
            });
          }
        } else {
          Flagship.error(
            "Failed to save record.",
            self.state.recordData.record.id,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Failed to save record: " + err,
          self.state.recordData.record.id,
          self.props.userId,
        );
      },
    );
  }

  saveAndExit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    let newLocation = self.state.nextLocation;
    this.saveRecord(function () {
      let oldData = JSON.parse(localStorage.getItem("initialRecordData"));
      let newData = JSON.parse(JSON.stringify(self.state.recordData));
      localStorage.setItem("initialRecordData", JSON.stringify(newData));

      let changedValues = [];

      // Check for name change
      if (!isEqual(oldData.record.record_name, newData.record.record_name)) {
        changedValues.push({
          label: "Name",
          old: oldData.record_name,
          new: newData.record_name,
          validation: "",
        });
      }

      // Get extra fields
      if (!isEqual(oldData.record.extra1, newData.record.extra1)) {
        changedValues.push({
          label: Flagship.config.records[self.props.route.type].extra1.label,
          old: oldData.record.extra1,
          new: newData.record.extra1,
          validation:
            Flagship.config.records[self.props.route.type].extra1.validation,
        });
      }

      if (!isEqual(oldData.record.extra2, newData.record.extra2)) {
        changedValues.push({
          label: Flagship.config.records[self.props.route.type].extra2.label,
          old: oldData.record.extra2,
          new: newData.record.extra2,
          validation:
            Flagship.config.records[self.props.route.type].extra2.validation,
        });
      }

      if (!isEqual(oldData.record.extra3, newData.record.extra3)) {
        changedValues.push({
          label: Flagship.config.records[self.props.route.type].extra3.label,
          old: oldData.record.extra3,
          new: newData.record.extra3,
          validation:
            Flagship.config.records[self.props.route.type].extra3.validation,
        });
      }

      if (!isEqual(oldData.record.extra4, newData.record.extra4)) {
        changedValues.push({
          label: Flagship.config.records[self.props.route.type].extra4.label,
          old: oldData.record.extra4,
          new: newData.record.extra4,
          validation:
            Flagship.config.records[self.props.route.type].extra4.validation,
        });
      }

      let fieldsChanged = [];

      // Check record data
      oldData.data.map(function (item, i) {
        if (
          empty(oldData.data[i].field_value) ||
          empty(newData.data[i].field_value) ||
          !isEqual(oldData.data[i].field_value, newData.data[i].field_value)
        ) {
          // If value does not match, add to changedValues array
          if (
            !isEqual(oldData.data[i].field_value, newData.data[i].field_value)
          ) {
            if (
              oldData.data[i].type !== "user" ||
              (oldData.data[i].field_value !== null &&
                oldData.data[i].field_value.id !==
                  newData.data[i].field_value) ||
              (oldData.data[i].field_value === null &&
                !empty(newData.data[i].field_value))
            ) {
              fieldsChanged.push(item.field_id);

              changedValues.push({
                label: oldData.data[i].label,
                old: empty(oldData.data[i].field_value)
                  ? ""
                  : oldData.data[i].field_value,
                new: empty(newData.data[i].field_value)
                  ? ""
                  : newData.data[i].field_value,
                validation: newData.data[i].validation,
              });
            }
          }
        }
      });

      newData.data.map(function (item, i) {
        if (!fieldsChanged.includes(item.field_id)) {
          changedValues.push({
            label: newData.data[i].label,
            old: "",
            new: empty(newData.data[i].field_value)
              ? ""
              : newData.data[i].field_value,
            validation: newData.data[i].validation,
          });
        }
      });

      window.onbeforeunload = null;

      self.setState({
        confirmExit: false,
        modified: false,
        activeTab: 0,
      });

      Flagship.notify("Changes saved.", "success");
      Flagship.event(
        "change",
        changedValues,
        self.state.recordData.record.id,
        self.props.userId,
      );

      if (newLocation) {
        browserHistory.push(newLocation);
      }
    });
  }

  cancelExit() {
    this.setState({
      confirmExit: false,
    });
  }

  cancelLaunchDateChange() {
    this.setState({
      showLaunchDateModal: false,
    });
  }

  onAddLineItem() {
    let recordData = Object.assign({}, this.state.recordData);
    this.setState({
      recordData: recordData,
    });
  }

  onStatusChange(e, data) {
    if (e !== null) e.preventDefault();

    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    let additionalData = {};

    if (!empty(data.additional)) {
      additionalData = data.additional;
    }

    if (self.state.recordData.record.record_status === data.value) {
      // Do nothing
    } else {
      if (
        self.props.route.type === "io" &&
        data.value === "launched" &&
        empty(additionalData)
      ) {
        // Get date launched first
        this.setState({
          showLaunchDateModal: true,
        });
      } else {
        Flagship.post(
          "change-record-status/" +
            self.state.recordData.record.id +
            "/" +
            data.value,
          additionalData,
          function (response) {
            if (response.data.success === true) {
              let recordData = Object.assign({}, self.state.recordData);
              recordData.record.record_status = data.value;

              self.setState(
                {
                  recordData: recordData,
                },
                function () {
                  Flagship.notify(
                    self.props.route.niceName + " status changed.",
                  );
                  Flagship.event(
                    "change-status-" + self.props.route.type,
                    data.value,
                    self.state.recordData.record.id,
                    self.props.userId,
                  );
                },
              );
            } else {
              Flagship.error(
                "Failed to change status.",
                self.state.recordData.record.id,
                self.props.userId,
              );
            }
          },
        );
      }
    }
  }

  onChangeLaunchDate(data) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState({
      launchDate: data,
    });
  }

  saveLaunchDate() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.setState(
      {
        showLaunchDateModal: false,
      },
      function () {
        this.onStatusChange(null, {
          value: "launched",
          additional: {
            closed: this.state.launchDate.unix(),
          },
        });
      },
    );
  }

  launchDateModal() {
    if (this.props.accessLevel !== 2) {
      return null;
    }

    return (
      <Modal open={true} onClose={this.cancelLaunchDateChange} closeIcon>
        <Header icon="save" content="Enter Launch Date" />
        <Modal.Content>
          <p>Please enter the date that this IO launched.</p>
          <div className="small-field">
            <div className="field-container clearfix">
              <div className="ui fluid input">
                <Icon
                  name="calendar"
                  color="grey"
                  style={{ marginTop: ".25em" }}
                  size="large"
                />
                <DatePicker
                  autoFocus={true}
                  onChange={this.onChangeLaunchDate}
                  value={this.state.launchDate.format("MM/DD/YYY")}
                  type="text"
                />
              </div>
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveLaunchDate}>
            <Icon name="save" /> Save Launch Date
          </Button>
          <Button secondary onClick={this.cancelLaunchDateChange}>
            <Icon name="cancel" /> Cancel Status Change
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  abandonChanges() {
    let originalRecordData = JSON.parse(
      localStorage.getItem("initialRecordData"),
    );
    let newLocation = this.state.nextLocation;
    this.setState(
      {
        confirmExit: false,
        modified: false,
        recordData: originalRecordData,
      },
      function () {
        if (newLocation) {
          browserHistory.push(newLocation);
        }
      },
    );
  }

  duplicateRecord() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    let recordType = self.state.recordData.record.record_type;
    Flagship.post(
      "duplicate-record/" + this.state.recordData.record.id,
      {},
      function (response) {
        if (response.data.success === true) {
          let duplicateRecord = Object.assign({}, self.state.recordData.record);
          duplicateRecord.record_status =
            Flagship.config.records[recordType].defaultStatus;
          duplicateRecord.extra3 = "";

          Flagship.event(
            "create-" + self.state.recordData.record.record_type,
            duplicateRecord,
            response.data.record_id,
            self.props.userId,
          );
          self.setState(
            {
              recordData: {},
              key: response.data.record_key,
              loading: true,
              activeTab: 0,
            },
            function () {
              Flagship.notify("Record duplicated.", "success");
              browserHistory.push(
                "/" + recordType + "/view/" + response.data.record_key,
              );
            },
          );
        } else {
          Flagship.error(
            "Failed to duplicate record.",
            self.state.recordData.record.id,
            self.props.userId,
          );
        }
      },
      function (err) {
        Flagship.error(
          "Failed to duplicate record: " + err,
          self.state.recordData.record.id,
          self.props.userId,
        );
      },
    );
  }

  handleCommentFilterUserChange(value) {
    this.setState({
      commentFilterUser: value,
    });
  }

  handleCommentFilterSearchChange(value) {
    this.setState({
      commentFilterSearch: value,
    });
  }

  handleTabChange(e, data) {
    let key, activeTab;

    if (typeof data.panes !== "undefined") {
      key = data.panes[data.activeIndex].menuItem.key;
      activeTab = data.activeIndex;
    } else {
      key = "comments";
      activeTab = this.getTabIndex("comments");
    }

    this.setState(
      {
        activeTab,
      },
      function () {
        if (key === "edit" && this.props.accessLevel === 2) {
          browserHistory.push(
            "/" +
              this.state.recordData.record.record_type +
              "/edit/" +
              this.state.recordData.record.record_key,
          );
        } else if (key === "view") {
          browserHistory.push(
            "/" +
              this.state.recordData.record.record_type +
              "/view/" +
              this.state.recordData.record.record_key,
          );
        } else if (key === "history") {
          browserHistory.push(
            "/" +
              this.state.recordData.record.record_type +
              "/history/" +
              this.state.recordData.record.record_key,
          );
        }
      },
    );
  }

  render() {
    if (this.props.route.type === "rfp" && this.props.userRole === "ae") {
      return <div className="white-text">Access to RFPs is denied.</div>;
    }

    if (
      typeof this.state.recordData.record === "undefined" ||
      this.state.loading === true
    ) {
      return (
        <Table className="fade-in">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let showLeaveConfirmation = this.showLeaveConfirmation.bind(this);

      let recordId = this.state.recordData.record.id;
      let showRecordEditStatus = this.showRecordEditStatus.bind(this);

      let changeStatusOptions;

      if (
        this.props.route.type === "io" &&
        (this.props.userRole === "dpm" ||
          this.props.userRole === "csm" ||
          this.props.userRole === "social" ||
          this.props.userRole === "admin")
      ) {
        changeStatusOptions = [];

        for (let property in Flagship.config.records[this.props.route.type]
          .statuses) {
          if (
            Flagship.config.records[
              this.props.route.type
            ].statuses.hasOwnProperty(property)
          ) {
            let option = {
              key: property,
              value: property,
              text: (
                <Label
                  content={
                    Flagship.config.records[this.props.route.type].statuses[
                      property
                    ].label
                  }
                  color={
                    Flagship.config.records[this.props.route.type].statuses[
                      property
                    ].color
                  }
                />
              ),
            };
            changeStatusOptions.push(option);
          }
        }
      }

      let viewPane = {
        menuItem: {
          key: "view",
          icon: "eye",
          content: "View " + this.props.route.niceName,
        },
        render: () => (
          <SingleRecordView
            isAdvisr={this.state.isAdvisr}
            recordData={this.state.recordData}
            recordFields={this.state.recordFields}
            getRecordData={this.getRecordData}
            recordType={this.props.route.type}
            onStatusChange={this.onStatusChange}
            viewingChild={this.state.viewingChild}
            onCloseModals={this.onCloseModals}
            onAddLineItem={this.onAddLineItem}
            updateLineItems={this.updateLineItems}
            route={this.props.route}
            onCancelRecord={this.onCancelRecord}
            hasContract={this.hasContract}
            hasAdvisrIo={this.hasAdvisrIo}
            instance={this.props.instance}
            onReactivateRecord={this.onReactivateRecord}
            userRole={this.props.userRole}
            readOnly={this.props.accessLevel !== 2}
            fieldData={this.state.fieldData}
          />
        ),
      };

      let editPane = {
        menuItem: {
          key: "edit",
          icon: "edit",
          content: "Edit " + this.props.route.niceName,
        },
        render: () => (
          <SingleRecordEdit
            isAdvisr={this.state.isAdvisr}
            recordId={this.state.recordData.record.id}
            recordFields={this.state.recordFields}
            recordData={this.state.recordData}
            fieldData={this.state.fieldData}
            editModeChange={this.editModeChange.bind(this)}
            onChangeName={this.recordNameChange.bind(this)}
            onChangeExtra={this.extraChange.bind(this)}
            saveAndExit={this.saveAndExit.bind(this)}
            router={this.props.router}
            route={this.props.route}
            modified={this.state.modified}
            showLeaveConfirmation={showLeaveConfirmation}
            requiredMissing={this.state.requiredMissing}
            errors={this.state.errors}
            name={this.state.recordData.record.record_name}
            extra1={this.state.recordData.record.extra1}
            extra2={this.state.recordData.record.extra2}
            extra3={this.state.recordData.record.extra3}
            extra4={this.state.recordData.record.extra4}
            addError={this.addError.bind(this)}
            clearError={this.clearError.bind(this)}
            confirmExit={this.state.confirmExit}
            cancelExit={this.cancelExit}
            instance={this.props.instance}
          />
        ),
      };

      // let duplicatePane = {
      //   menuItem: (
      //     <Menu.Item
      //       className="record-tab-duplicate"
      //       key="duplicate"
      //       onClick={this.duplicateRecord}
      //     >
      //       <Icon name="copy" />
      //       Duplicate {this.props.route.niceName}
      //     </Menu.Item>
      //   ),
      //   render: () => <div>An error occurred.</div>,
      // };

      let historyPane = {
        menuItem: (
          <Menu.Item className="record-tab-history" key="history">
            <Icon name="history" />
            History
            {this.state.historyCount !== false &&
            this.state.historyCount > 0 ? (
              <Label className="record-history-count">
                {this.state.historyCount}
              </Label>
            ) : null}
          </Menu.Item>
        ),
        render: () => (
          <SingleRecordHistory
            recordId={this.state.recordData.record.id}
            route={this.props.route}
          />
        ),
      };

      let commentsPane = {
        menuItem: (
          <Menu.Item className="record-tab-comments" key="comments">
            <Icon name="comment" />
            Comments
            {this.state.commentCount !== false &&
            this.state.commentCount > 0 ? (
              <Label className="record-comment-count" color="red">
                {this.state.commentCount}
              </Label>
            ) : null}
          </Menu.Item>
        ),
        render: () => (
          <SingleRecordComments
            recordId={recordId}
            recordKey={this.state.recordData.record.record_key}
            lineItems={this.state.lineItems}
            recordType={this.state.recordData.record.record_type}
            viewMoreComments={this.handleTabChange}
            commentFilterUser={this.state.commentFilterUser}
            commentFilterSearch={this.state.commentFilterSearch}
          />
        ),
      };

      const panes =
        this.props.userRole !== "ae" && this.props.accessLevel === 2
          ? [viewPane, editPane, historyPane, commentsPane]
          : [viewPane, historyPane, commentsPane];
      const activeTab =
        this.state.activeTab < panes.length ? this.state.activeTab : 0;
      const commentTabIndex = this.getTabIndex("comments");

      return (
        <div className="fade-in">
          <SingleRecordHeader
            recordKey={this.state.recordData.record.record_key}
            recordName={this.state.recordData.record.record_name}
            recordType={this.state.recordData.record.record_type}
            recordMarket={this.state.recordData.record.market}
            recordStatus={this.state.recordData.record.record_status}
            creatorFirstName={this.state.recordData.record.first_name}
            creatorLastName={this.state.recordData.record.last_name}
            creatorPhoto={this.state.recordData.record.photo}
          />

          <Segment className="single-record-main cf" attached="top">
            <Grid stackable>
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={16}
                largeScreen={12}
                widescreen={12}
                width={16}
              >
                <Tab
                  className="single-record-tab-nav"
                  panes={panes}
                  onTabChange={this.handleTabChange}
                  activeIndex={activeTab}
                />
              </Grid.Column>

              <Grid.Column
                className={
                  this.state.recordData.record.record_status === "draft"
                    ? "record-unsubmitted"
                    : "comments-column"
                }
                mobile={16}
                tablet={16}
                computer={16}
                largeScreen={4}
                widescreen={4}
                width={16}
              >
                {this.state.recordData.record.record_status === "draft" &&
                this.props.userRole !== "ae" &&
                this.props.accessLevel === 2 ? (
                  <div>
                    <div className="record-top-right">
                      <FavoriteIcon
                        recordId={recordId}
                        isFavorite={this.isFavorite()}
                      />

                      {this.props.route.mode !== "edit" ? (
                        <SubscribeButton
                          recordId={recordId}
                          subscribers={this.state.recordData.subscribers}
                          recordNiceName={this.props.route.niceName}
                        />
                      ) : (
                        showRecordEditStatus()
                      )}
                      {this.props.route.type !== "client" &&
                      !empty(this.state.recordData.record.record_key) ? (
                        <span className="record-key-header">
                          #{this.state.recordData.record.record_key}
                        </span>
                      ) : null}
                    </div>

                    {this.props.route.mode !== "edit" ? (
                      <div className="record-comments">
                        <Divider hidden />
                        <Header as="h3">
                          <Icon size="mini" name="warning sign" color="red" />
                          Submit this {this.props.route.niceName}
                        </Header>
                        <Divider />
                        <p>
                          This {this.props.route.niceName} is still a draft. You
                          must submit it for it to be received.
                        </p>
                        {this.state.lineItems.length &&
                        (this.state.recordData.record.record_type !== "io" ||
                          this.state.hasContract === true) ? (
                          <div className="pulsing-button-wrap">
                            <Button
                              icon="send"
                              color="black"
                              style={{
                                marginRight: "1em",
                                marginBottom: ".5em",
                              }}
                              content={"Submit " + this.props.route.niceName}
                              onClick={this.onSubmitRecord}
                              className="pulsing-button-pulsing alternate"
                            />
                            <Button
                              icon="cancel"
                              content={"Cancel " + this.props.route.niceName}
                              onClick={this.onCancelRecord}
                            />
                          </div>
                        ) : (
                          <div>
                            <p>
                              {this.state.lineItems.length ? (
                                <span>
                                  Add some
                                  {this.state.recordData.record.record_type ===
                                  "rfp"
                                    ? " line items "
                                    : " products "}
                                  to get started.
                                </span>
                              ) : (
                                <span>
                                  <strong>Upload the signed contract</strong> in
                                  the box
                                  {this.props.screenWidth >= 1200
                                    ? " to the left "
                                    : " above "}
                                  first, and make sure you've also added some
                                  line items.
                                </span>
                              )}
                            </p>
                            <Button
                              icon="cancel"
                              content={"Cancel " + this.props.route.niceName}
                              onClick={this.onCancelRecord}
                            />
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div>
                    <div className="record-top-right">
                      <FavoriteIcon
                        recordId={recordId}
                        isFavorite={this.isFavorite()}
                      />

                      {this.props.route.mode === "view" ? (
                        <SubscribeButton
                          recordId={recordId}
                          subscribers={this.state.recordData.subscribers}
                          recordNiceName={this.props.route.niceName}
                        />
                      ) : (
                        showRecordEditStatus()
                      )}
                      {this.props.route.type !== "client" &&
                      !empty(this.state.recordData.record.record_key) ? (
                        <h2 className="record-key-header">
                          #{this.state.recordData.record.record_key}
                        </h2>
                      ) : null}
                    </div>
                    <CommentBox
                      viewMode="collapsed"
                      search={activeTab === commentTabIndex}
                      recordId={recordId}
                      recordKey={this.state.recordData.record.record_key}
                      lineItems={this.state.lineItems}
                      recordType={this.state.recordData.record.record_type}
                      viewMoreComments={this.handleTabChange}
                      onCommentFilterUserChange={
                        this.handleCommentFilterUserChange
                      }
                      onCommentFilterSearchChange={
                        this.handleCommentFilterSearchChange
                      }
                      commentFilterUser={false}
                      commentFilterSearch={false}
                    />
                  </div>
                )}
              </Grid.Column>
            </Grid>
          </Segment>

          <SingleRecordFiles
            folder={
              this.props.route.type +
              "/" +
              this.state.recordData.record.record_key
            }
            recordId={this.state.recordData.record.id}
            userId={this.props.userId}
          />

          {this.state.showLaunchDateModal === true
            ? this.launchDateModal()
            : null}
        </div>
      );
    }
  }
}

SingleRecord.propTypes = {
  actions: PropTypes.object,
  token: PropTypes.string,
  niceName: PropTypes.string,
  username: PropTypes.string,
  userId: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    accessLevel: state.main.accessLevel,
    userInstance: state.main.userInstance,
    screenWidth: state.main.screenWidth,
    instance: state.main.instance,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleRecord);



// WEBPACK FOOTER //
// ./src/components/views/SingleRecord.js